<!--
  CustomerDateFilter is a wrapper around the DatesFilterWithCustomRange component.
  It is used to filter customers by date range.
-->

<script>
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';
import DatesFilterWithCustomRange from '@/V2/components/filters/DatesFilterWithCustomRange';

export default {
  components: {
    DatesFilterWithCustomRange,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    onRangeChanged(range) {
      // Add 1 day to make the end date inclusive
      let endDate = new Date(range.endDate);
      endDate.setDate(endDate.getDate() + 1);
      endDate = this.$moment(endDate).format('YYYY-MM-DD');
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          startDate: range.startDate,
          endDate: endDate,
          custom_range: range.customRange,
        },
      });
    },
  },
};
</script>

<template>
  <dates-filter-with-custom-range
    :params="params"
    @dates-filter-updated="onRangeChanged"
  ></dates-filter-with-custom-range>
</template>
